import AddressSearchModel from './AddressSearchModel'

export default AddressSearchModel
